import { render, staticRenderFns } from "./StrategyWizard.vue?vue&type=template&id=4e088d39&scoped=true"
import script from "./StrategyWizard.vue?vue&type=script&lang=js"
export * from "./StrategyWizard.vue?vue&type=script&lang=js"
import style0 from "./StrategyWizard.vue?vue&type=style&index=0&id=4e088d39&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e088d39",
  null
  
)

export default component.exports